import { AfterViewInit, Component, computed, DestroyRef, effect, ElementRef, HostListener, inject, NgZone, OnInit, PLATFORM_ID, QueryList, Renderer2, signal, untracked, ViewChild, ViewChildren } from '@angular/core';
import { Banner, FollowApiResponse, followData, followRequest, JobDetails, jobDetailsExistingData, JobDetailsResponse, MatchingRequest, MatchingResponse, matchingResponse, MoreJobsData, MoreJobsPayload, SectionConfig, SectionId, shortlistBody, shortListResponse } from '../../details/models/details.model';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { catchError, filter, finalize, fromEvent, map, of, shareReplay, tap } from 'rxjs';
import { Meta, Title } from '@angular/platform-browser';
import { CookieService } from '../../../core/services/cookie/cookie.service';
import { JobDetailService } from '../../details/services/job-details.service';
import { ActivatedRoute, NavigationStart, Params, Router, RouterLink } from '@angular/router';
import { AppliedJobsUrl, BdjobsSigninUrl, Cookies, EmailCVUrl, FacebookShareUrl, LinkedinShareUrl, LocalStorageItem, MatchingStatus, PricingPageUrl, SharedItem, WhatsappShareUrl } from '../../../shared/enums/app.enums';
import { DatePipe, isPlatformBrowser, NgClass } from '@angular/common';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { OverseasPopupComponent } from '../../details/components/overseas-popup/overseas-popup';
import { AccessibilityAccordion } from "../../details/components/accessibility-accordion/accessibility-accordion";
import { ReportJobCompany } from "../../details/components/report-job-company/report-job-company";
import { MoreJobsModal } from "../../details/components/more-jobs-modal/more-jobs-modal";
import { ExpiredJobComponent } from "../../details/components/expired-job/expired-job";
import { BannerComponent } from "../../../shared/components/banner/banner";
import { LocalstorageService } from '../../../core/services/essentials/localstorage.service';
import { ToasterService } from '../../../shared/services/toaster.service';
import { SavedJobsCacheService } from '../../company insight/services/saved-jobs-cache.service';
import { ConfirmationModalService, ModalConfig } from '../../../core/services/confirmationModal/confirmation-modal.service';
import { DetailsUtilService } from '../../details/services/details-utils.service';
import { Advertise } from "../../../shared/components/advertise/advertise";
import { Summary } from "../../details/components/summary/summary";
import { DetailsMain } from "../../details/components/details-main/details-main";
import { ApplicationInsights } from '../../details/components/application-insights/application-insights';
import { ToBanglaNumberPipe } from '../../../shared/pipes/toBanglaNumber.pipe';
import { CircularLoaderService } from '../../../core/services/circularLoader/circular-loader.service';
import { HighlightDirective } from '../../../core/directives/highlighter.dir';
import { QueryService } from '../../jobs/services/query.service';
import { NewspaperJobDetails } from "../../details/components/newspaper-job-details/newspaper-job-details";
import { DeviceDetectionService } from '../../../core/services/device-detection/device-detection.service';
import { SharedService } from '../../jobs/services/shared.service';

import { MatchingScoreItem } from '../../apply/interfaces/apply.interface';
import { AnalyticsViewEnum, JOBS_URL } from '../../../shared/consts/shared.const';
import { constructRedirectURL, trackButtonClick } from '../../jobs/utils/functions';
import { JobAnalyticsService } from '../../../shared/services/Analytics.service';
import { CompanyInsightService } from '../../company insight/services/company-insight.service';
import { CompanyInsightApiEventData, CompanyInsightApiIndustryInfo } from '../../company insight/models/company-insight.model';
import { CompanyInfoCard } from '../../company insight/components/company-info-card/company-info-card';
import { COMPANY_INSIGHT, hasCompanyInsightData } from '../../company insight/utils/company-insight.utils';
import { AdsPanel } from "../../jobs/components/ads-panel/ads-panel";
import { ShareJobModal } from '../../company insight/modals/share-job-modal/share-job-modal';
import { MatchingSection } from "../../details/components/matching-section/matching-section";
import { environment } from '../../../../environments/environment.development';

@Component({
  selector: 'app-details',
  imports: [
    NgClass,
    TranslocoModule,
    DatePipe,
    AccessibilityAccordion,
    ReportJobCompany,
    OverseasPopupComponent,
    MoreJobsModal,
    ExpiredJobComponent,
    BannerComponent,
    Advertise,
    Summary,
    ApplicationInsights,
    DetailsMain,
    ToBanglaNumberPipe,
    RouterLink,
    HighlightDirective,
    NewspaperJobDetails,
    CompanyInfoCard,
    AdsPanel,
    MatchingSection
    ,ShareJobModal
],
  templateUrl: './details.html',
  styleUrl: './details.scss',
})
export class Details implements OnInit, AfterViewInit {
  environment = environment;
  private meta = inject(Meta);
  private deviceDetectionService = inject(DeviceDetectionService);
  private cookieService = inject(CookieService);
  private jobDetailsService = inject(JobDetailService);
  private localStorageService = inject(LocalstorageService);
  private sharedService = inject(SharedService)
  private destroyRef = inject(DestroyRef);
  private renderer = inject(Renderer2);
  private route = inject(ActivatedRoute);
  private titleService = inject(Title);
  private router = inject(Router);
  private platformId = inject(PLATFORM_ID);
  private toasterService = inject(ToasterService);
  private savedJobsCache = inject(SavedJobsCacheService);
  protected transloco = inject(TranslocoService);
  protected detailsUtilService = inject(DetailsUtilService);
  private circularLoaderService = inject(CircularLoaderService);
  private queryService = inject(QueryService);
  private analyticsService = inject(JobAnalyticsService)
  private ngZone = inject(NgZone);
  private companyInsightService = inject(CompanyInsightService);
  private modalService = inject(ConfirmationModalService);

  isBrowser = isPlatformBrowser(this.platformId);
  isSmallDevice = false;
  isShow = signal(false);
  isShowLocation = signal(false);

  isFollowed = signal(false);
  FollowMsg: string = '';
  isFollowedLocal = signal(false);
  IsShortlistedLocal = signal(true);
  followResponse: followData | null = null;

  JobLanType: string = '1';
  isShortListed = signal(false);
  mess: string = '';
  shortListMsg: string = '';
  shortListedValue: number = 0;

  jobDetails = signal<JobDetails | null>(null);

  linkedinUrl = LinkedinShareUrl;
  facebookUrl = FacebookShareUrl;
  whatsappUrl = WhatsappShareUrl;
  signinUrl = BdjobsSigninUrl;
  pricingPageUrl = PricingPageUrl
  emailCvUrl = EmailCVUrl
  appliedJobsUrl = AppliedJobsUrl
  jobs_url = JOBS_URL;
  matchingStatus = MatchingStatus
  jobUrl = '';

  applyEmailBdjobs: string = '';
  jobId: string = '';
  addExperiecne: string = '';
  errorMessage: string | null = null;

  responseData: FollowApiResponse | null = null;
  // matchingData: matchingResponse[] = [];
  matchingData = signal<matchingResponse[]>([])
  match: matchingResponse[] = [];
  moreJobs = signal<MoreJobsData[]>([]);
  remainingData = signal({} as jobDetailsExistingData);
  MatchingList = signal<MatchingResponse[]>([])

  selected = signal<string | null>(null);
  canScrollLeft = signal(false);
  canScrollRight = signal(true);

  isApiCalled = signal(false);
  isDisabilityUser = signal(false);
  selectedSection: string = 'allSection';

  formValue: string = decodeURIComponent(
    this.cookieService.getCookie(Cookies.MyBDJOBSUSERID) ?? ''
  );
  MybdjobsGuid = computed(() => decodeURIComponent(
    this.cookieService.getCookie(Cookies.MYBDJOBSGID) ?? ''
  ));
  deviceType: string = SharedItem.DEVICE;
  encoded: string = SharedItem.ENCODED;
  Alias_Status: number = SharedItem.ALIAS_STATUS;

  JobID = signal(0);

  statuscode = signal('');
  totalShortlisted = signal(0);
  totalViewed = signal(0);

  isVisible = signal(true);
  isApplyOnlineURL = signal(true);
  isLoading = signal(true);
  matchingApiCalled = signal(false);
  showLoader = signal(false);
  showInsightLoader = false;
  isInsightOpen: boolean = false;
  isMoreJobModalOpen: boolean = false;
  isShareModalOpen = signal(false);
  isOptionsOpen = signal(false);
  showWhatsapp = signal(true);

  toggleOptions(): void {
    this.isOptionsOpen.update(isOpen => !isOpen);
  }

  @HostListener('document:click', ['$event'])
  closeOptionsOnOutsideClick(event: Event): void {
    if (
      this.isBrowser &&
      this.isOptionsOpen() &&
      this.optionsMenu?.nativeElement.contains(event.target as Node) !== true
    ) {
      this.isOptionsOpen.set(false);
    }
  }

  isOverseasModalOpen = signal(false);
  isTooltipVisible = signal(false);
  isCompanyBusinessExpanded = signal(false);
  isFromCompanyInsight = signal(this.router.getCurrentNavigation()?.extras?.state?.['fromCompanyInsight'] === COMPANY_INSIGHT);
  protected readonly savedJobsId = signal<string[] | null>(null);

  searchQuery = toSignal(this.queryService.keyword$, { initialValue: '' });
  isMobileDevice = computed(() => this.deviceDetectionService.isMobileOrTablet());

  @ViewChild('topElement') topElement!: ElementRef;
  @ViewChild('accessElement') accessElement!: ElementRef;
  @ViewChild('optionsMenu') optionsMenu!: ElementRef<HTMLElement>;
  @ViewChild('navigationContainer', { static: false }) container!: ElementRef<HTMLElement>;
  @ViewChildren('sectionButton') sectionButtons!: QueryList<ElementRef<HTMLButtonElement>>;
  @ViewChild('navContainer') navContainer!: ElementRef<HTMLElement>;
  @ViewChildren('tabBtn') tabBtns!: QueryList<ElementRef<HTMLButtonElement>>;

  readonly isClosed = computed(() =>
    this.isCorporate() ? 0 : this.jobDetails()?.Closed ?? 0
  );
  readonly comBusiness = computed(
    () => this.jobDetails()?.CompanyBusiness.replace(/\r\n/g, '<br/>') ?? ''
  );

  readonly hardCopy = computed(
    () =>{
      const hardCopyValue =  this.jobDetails()?.HardCopy.replace(
        /<a /g,
        '<p class="" '
      ) ?? ''
      return this.detailsUtilService.fixSingleAnchor(hardCopyValue)
    }

  );
  readonly app_url = computed(() =>
    this.detailsUtilService.fixSingleAnchor(this.jobDetails()?.ApplyURL ?? '')
  );

  readonly CompanyWeb = computed(() => {
    const url = this.jobDetails()?.CompanyWeb?.trim() || '';
    return url.startsWith('http://') || url.startsWith('https://')
      ? url
      : `https://${url}`;
  });

  readonly isRequirements = computed(() => {
    return !!(
      this.jobDetails()?.EducationRequirements ||
      this.jobDetails()?.experience ||
      this.jobDetails()?.AdditionJobRequirements ||
      (this.jobDetails()?.Age && this.jobDetails()?.Age !== 'Na')
    );
  });

  readonly isResponsibilities = computed(
    () => !!this.jobDetails()?.JobDescription
  );
  readonly isSkill = computed(() => {
    const details = this.jobDetails();
    return (
      (details?.SkillsRequired?.trim().length ?? 0) > 0 ||
      (details?.SuggestedSkills?.trim().length ?? 0) > 0
    );
  });
  readonly isSalary = computed(() => !!this.jobDetails()?.JobOtherBenifits);

  readonly canNavigateToCompanyInsight = computed(() => {
    const details = this.jobDetails();
    return (
      details?.HaveAliasName === false &&
      details?.OnlineJob === true &&
      hasCompanyInsightData(this.companyInsight())
    );
  });

  protected readonly companyInsight = signal<CompanyInsightApiEventData | null>(null);

  isProUser = toSignal(
    this.sharedService.isProuser$,
    {initialValue:false}
  )

  queryParams = toSignal(this.route.queryParams, { initialValue: {} as Params });

  isCorporate = computed(() =>
    this.queryParams()?.['src'] === 'recruiter.bdjobs.com'
  );

  fromApplied = computed(() => {
    const code = this.queryParams()?.['code'];
    return typeof code === 'string' && code.trim() !== '';
  });

  isCorporateLoggedIn = computed(() => this.cookieService.getCookie(Cookies.AUTH) !== null);

  shouldNotNavigateToApplyOnline = computed(() => {
    return (this.isCorporateLoggedIn() && this.jobDetails()?.Verified === false);
  });

  private readonly navigationState = signal(this.router.getCurrentNavigation()?.extras?.state) ?? '';
  private readonly navigationOrigin = computed(() => {
    const state = this.navigationState();
    if (state?.['fromHome'] === 'home'){
      return 'home'
    }
    if (state?.['fromCompanyInsight'] === COMPANY_INSIGHT){
      return COMPANY_INSIGHT;
    }
    return 'jobs'
  })

  banners = toSignal(
    this.jobDetailsService.getBannerList().pipe(
      takeUntilDestroyed(this.destroyRef),
      map((banner: Banner[]) => [
        ...banner,
        {
          TopicName: 'Employability Skills Course',
          TrainingFee: 'FREE!',
          TName: 'Self-paced Learning',
          isnew: true,
        },
      ])
    ),

    { initialValue: [] }
  );

  // sections = this.detailsUtilService.getSections({
  //   isRequirements: this.isRequirements(),
  //   isResponsibilities: this.isResponsibilities(),
  //   isSkill: this.isSkill(),
  //   isSalary: this.isSalary(),
  // });
  // From matching breakdown api
  protected readonly applicantMatchingScore = computed(() => {
    return this.MatchingList()[0]?.applicantMatchingScore ?? 0;
  })

  protected readonly topApplicantMatchingPercentage = computed(() => {
    return this.MatchingList()[0]?.topApplicantMatchingPercentage ?? 0;
  });


  // from matchingScore breakdown api
  protected readonly hasMandatoryUnmatched = computed(() => {
    return this.MatchingList().some(item => {
      if (!item.isMandatory) return false;

      const status = item.status?.toLowerCase();
      const criteria = item.criteriaName?.toLowerCase();
      // Experience + partly matched: only block on specific reason
      if (criteria.toLowerCase() === 'experience' && status.toLowerCase() === 'partly matched') {
        return false
      }

      return status !== 'matched';
    });
  });

  constructor() {
    this.circularLoaderService.setLoading(false);
    const details = this.route.snapshot.data['detail'] as JobDetailsResponse;
    if(details.statuscode === '300') {
      return;
    }
    if (details !== null) {
      this.setJobDetails(details);
    }
    effect(() => {
      console.log('is pro user from details', this.isProUser());
    });

    this.fetchSavedJobs();
    effect(() => {
      const savedJobsIds = this.savedJobsId();
      this.IsShortlistedLocal.set(savedJobsIds?.includes(details.data[0].JobId.toString()) ?? false);
    })

    effect(() => {
      const activeId = this.activeSection();
      // wait a tick so the QueryList/DOM is ready
      if(this.isBrowser){
        queueMicrotask(() => this.scrollActiveTabIntoView(activeId));
      }
      
    });

    // effect(() => {
    //   const isShortlisted = this.IsShortlistedLocal();
    //   console.log('isShortlisted', isShortlisted);
    //   if (this.queryParams()?.['p'] === 'Shortlist' && !isShortlisted){
    //     this.shortLists();
    //   }
    // })
  }

  private setJobDetails(details: JobDetailsResponse) {
    if (details.statuscode === '0') {
      this.jobDetails.set(details.data[0]);
      this.localStorageService.setItem(LocalStorageItem.PREFERRED_VIDEO_RESUME, JSON.stringify(this.jobDetails()?.PreferVideoResume));

      if (this.jobDetails()) {
        this.updateMetaTag();
      }

      const companyId = this.jobDetails()?.CompanyID?.toString() ?? '';
      if (companyId && this.jobDetails()?.HaveAliasName === false) {
        this.loadCompanyInsight(companyId);
      }

      // this.transloco.langChanges$
      //   .pipe(takeUntilDestroyed(this.destroyRef))
      //   .subscribe(() => this.updateSections());

      this.remainingInfo(
        this.deviceType,
        this.formValue,
        parseInt(this.jobDetails()?.JobId ?? ''),
        this.jobDetails()?.CompanyID ?? '',
        this.jobDetails()?.CompnayName ?? ''
      );
      this.jobDetails.set(
        this.detailsUtilService.processStringProperties(
          this.jobDetails() ?? ({} as JobDetails)
        )
      );

      const shouldShow = computed(() => {
        if (this.isCorporate()) return true;
        return new Date(this.jobDetails()?.Deadline ?? '') > this.getNextDay();
      });
      this.isShow.set(shouldShow());

      if (this.jobDetails()?.overseasnote && this.isShow()) {
        this.isOverseasModalOpen.set(true);
      }
    } else if (details.statuscode === '1') {
      this.statuscode.set('1');
    }
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.checkScreenSize();
      this.isDisabilityUser.set((this.cookieService.getCookie('DisabilityUser') ?? '') === '1');
    }
    const jobId = +this.route.snapshot.paramMap.get('id')!;
    this.JobID.set(jobId);
    if(this.JobID()){
      if (this.JobID() && this.isBrowser) {
        this.logJobsAnalytics(parseInt(this.JobID().toString()));
      }
    }
    if (!jobId) {
      this.errorMessage = 'Invalid job ID.';
      return;
    }
    this.saveJobDetailsViewData(this.JobID().toString());
  }

  ngAfterViewInit(): void {
    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationStart),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((event: NavigationStart) => {
        if (event.navigationTrigger === 'popstate') {
          this.handleBackNavigation()
        }
      });

    if (this.isBrowser) {
      this.jobUrl = window.location.href;
      // Additional check for document availability in test environments
      if (typeof document !== 'undefined' && document !== null) {
        fromEvent<MouseEvent>(document, 'click')
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((event) => {
            const target = event.target as HTMLElement;
            const isInsideButton = target.closest('.scroll-button');
            if (isInsideButton === null) {
              this.selected.set(null);
            }
          });
      }

      const containerEl = this.container?.nativeElement;
      if (containerEl !== null && containerEl !== undefined) {
        this.updateScrollButtons(containerEl);
        fromEvent(containerEl, 'scroll')
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(() => this.updateScrollButtons(containerEl));
      }
    }
  }

  remainingInfo(
    deviceType: string,
    formValue: string,
    jobId: number,
    CompanyId: string,
    CompanyName: string
  ) {
    this.jobDetailsService
      .getRemainingData(
        deviceType,
        formValue,
        jobId,
        CompanyId,
        CompanyName
      )
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response) => {
          if (response !== null && response.data !== null) {
            this.remainingData.update(() => response.data as jobDetailsExistingData);
            this.localStorageService.setItem(
              'IsFollowed',
              this.remainingData().IsFollowed.toString()
            );
            this.isFollowedLocal.set(
              this.localStorageService.getItem('IsFollowed') === 'true'
                ? true
                : false
            );

            // const cachedIds = this.savedJobsCache.getSavedJobsBasedOnUser(this.MybdjobsGuid());
            // const isSavedFromCache = cachedIds?.includes(this.jobDetails()?.JobId ?? '');
            // const initialShortlistState = isSavedFromCache ?? this.remainingData().IsShortlisted;
            // this.IsShortlistedLocal.set(initialShortlistState);
            // this.remainingData().IsShortlisted = initialShortlistState;

            this.isVisible.set(false)
            this.route.queryParams
              .pipe(
                filter(
                  (params) =>
                    params['p'] === 'follow' || params['p'] === 'Shortlist'
                )
              )
              .subscribe((params) => {
                const p = params['p'];

                if (p === 'follow' && !this.isFollowedLocal()) {
                  this.follow();
                }

                // if (p === 'Shortlist' && !this.IsShortlistedLocal()) {
                //   this.shortLists();
                // }
              });
          }
        },
        error: (err) => {
          console.error('Error fetching remaining data', err);
        },
      });
  }

  private fetchSavedJobs(): void {
    this.savedJobsCache.getSavedJobs(this.MybdjobsGuid()).pipe(
      catchError(() => of(null)),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(ids => this.savedJobsId.set(ids));
  }

  MatchingScoreBreakdown(): void {
    if(this.MatchingList().length === 0){
      const payload: MatchingRequest = {
        GuidId: this.MybdjobsGuid(),
        JobId: Number(this.jobDetails()?.JobId ?? 0)
      };

      this.jobDetailsService.getMatchingInfo(payload)
      .pipe(
          tap((response) => this.updateMatchingScoreStorage(response)),
          finalize(() => this.matchingApiCalled.set(true)),
          takeUntilDestroyed(this.destroyRef)
        )
        .subscribe(response => {
          this.MatchingList.set(response)
      });
    }
  }

  // matchingPercentage():void {
  //   if (this.matchingData().length > 0) {
  //     this.matchingApiCalled.set(true);
  //     return;
  //   }
  //   this.showLoader.set(true);
  //   this.jobDetailsService
  //     .getMatchingPercentage(
  //       this.encoded,
  //       +(this.jobDetails()?.JobId ?? ''),
  //       this.formValue,
  //       this.deviceType
  //     )
  //     .pipe(
  //       takeUntilDestroyed(this.destroyRef),
  //       tap((matchingData) => {
  //         const jobId = this.JobID().toString();
  //         const score = matchingData?.[0]?.ApplicantMatchingScore?.toString() ?? '0';
  //         const matchingArr = this.localStorageService.getItem(
  //           LocalStorageItem.MATCHING_SCORE_ARR
  //         );
  //         let matchingScoreStorageArr: MatchingScoreItem[] = [];
  //         if (matchingArr && matchingArr.trim().startsWith('[')) {
  //           const parsedMatchArray = JSON.parse(matchingArr);
  //           if (Array.isArray(parsedMatchArray)) {
  //             matchingScoreStorageArr = parsedMatchArray;
  //           }
  //         }
  //         const existingIndex = matchingScoreStorageArr.findIndex(
  //           (item:MatchingScoreItem) => item.jobId === jobId
  //         );

  //         if (existingIndex !== -1) {
  //           matchingScoreStorageArr[existingIndex].matchingScore = score;
  //         } else {
  //           matchingScoreStorageArr.push({
  //             jobId: jobId,
  //             matchingScore: score
  //           });
  //           if (matchingScoreStorageArr.length > 10) {
  //             matchingScoreStorageArr.shift();
  //           }
  //         }

  //         this.localStorageService.setItem(
  //           LocalStorageItem.MATCHING_SCORE_ARR,
  //           JSON.stringify(matchingScoreStorageArr)
  //         );
  //       }),
  //       catchError(() => {
  //         const defaultMatchingResponse: matchingResponse = {
  //           ProUser: 0,
  //           ApplicantMatchingScore: 0,
  //           TopApplicantMatchingPercentage: 0
  //         };
  //         this.showLoader.set(false);
  //         this.matchingApiCalled.set(true);
  //         return of([defaultMatchingResponse]);
  //       }),
  //       finalize(() => {
  //         this.showLoader.set(false);
  //         this.matchingApiCalled.set(true);
  //       })
  //     )
  //     .subscribe({
  //       next: (data) => {
  //         this.matchingData.set(data);
  //       },
  //       error: (err) => {
  //         console.log(err)
  //       },
  //     });
  // }

  private updateMetaTag() {
    const jobDetails = this.jobDetails;
    const jobDetailsUrl = environment.jobDetailsBaseUrl+this.jobDetails()?.JobId
    const description = (jobDetails()?.JobDescription ?? '').replace(/<[^>]*>/g, '');
    const title = this.jobDetails()?.JobTitle + ' : ' + jobDetails()?.CompnayName + ' ' + '|| Bdjobs.com'
    const imgUrl = `https://assets.bdjobs.com/corporate/SharedImage/jobs/S_${this.jobDetails()?.JobId}_LA.jpeg`;
    this.jobDetailsService.checkImageExists(imgUrl)
    .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((finalImgUrl) => {
      this.titleService.setTitle(
        title
      );
      this.meta.updateTag({
        name: 'keywords',
        content: jobDetails()?.JobKeyPoints ?? '',
      });
      this.meta.updateTag({
        property: 'og:url',
        content: jobDetailsUrl,
      });
      this.meta.updateTag({
        property: 'og:title',
        content: title
      });
      this.meta.updateTag({
        property: 'og:image',
        content: finalImgUrl,
      });
      this.meta.updateTag({
        name: 'description',
        content: description,
      });
      this.meta.updateTag({
        property: 'og:type',
        content: 'website'
      });
      this.meta.updateTag({
        name: 'twitter:card',
        content: 'summary_large_image'
      });
      this.meta.updateTag({
        name: 'twitter:url',
        content: jobDetailsUrl,
      });
      this.meta.updateTag({
        name: 'title',
        content: title
      });
      this.meta.updateTag({
        name: 'twitter:title',
        content: title
      });
      this.meta.updateTag({
        property: 'og:description',
        content: description
      });
      this.meta.updateTag({
        name: 'twitter:description',
        content: description,
      });
      this.meta.updateTag({
        name: 'twitter:image',
        content: finalImgUrl,
      });
    })
  }

  selectButton(direction: 'left' | 'right') {
    this.selected.set(direction);
  }

  updateScrollButtons(container: HTMLElement) {
    if (this.isBrowser && container !== null && container !== undefined) {
      const scrollLeft = container.scrollLeft;
      const maxScrollLeft = container.scrollWidth - container.clientWidth;

      this.canScrollLeft.set(scrollLeft > 0);
      this.canScrollRight.set(scrollLeft < maxScrollLeft - 5);
    }
  }

  getCurrentUrl(): string {
    return this.router.url;
  }

  getNextDay(): Date {
    const nextDay = new Date();
    nextDay.setDate(nextDay.getDate() - 1);
    return nextDay;
  }

  toggleLocation() {
    this.isShowLocation.set(!this.isShowLocation());
  }

  scrollRight() {
    if (this.isBrowser) {
  const container = this.container?.nativeElement;
  if (container === null) return;

  const button = this.sectionButtons.first?.nativeElement;
  if (button === null) return;
      const isMediumDevice =
        window.innerWidth <= 1200 && window.innerWidth > 900;
      const isSmallDevice = window.innerWidth <= 900;
      let divisionFactor = 1.3;
      if (isSmallDevice) divisionFactor = 0.2;
      else if (isMediumDevice) divisionFactor = 0.3;
      const scrollAmount = button.offsetWidth / divisionFactor;
      this.ngZone.runOutsideAngular(() => {
        container.scrollBy({
          left: scrollAmount,
          behavior: 'smooth',
        });
        if (container !== null && container !== undefined) {
          container.addEventListener(
            'scrollend',
            () => this.updateScrollButtons(container),
            { once: true }
          );
        }
      });
    }
  }

  scrollLeft() {
    if (!this.isBrowser) return;

    const container = this.container?.nativeElement;
    if (container === null) return;

    const isSmallDevice = window.innerWidth <= 640; // small device threshold for left scrolling
    const divisionFactor = isSmallDevice ? 1 : 2;

    this.ngZone.runOutsideAngular(() => {
      container.scrollBy({
        left: -container.offsetWidth / divisionFactor,
        behavior: 'smooth',
      });

      if (container !== null && container !== undefined) {
        container.addEventListener(
          'scrollend',
          () => this.updateScrollButtons(container),
          { once: true }
        );
      }
    });
  }

  follow() {
    const applyRedirectURL = constructRedirectURL('fe', `follow/${this.jobDetails()?.JobId}`, this.transloco.getActiveLang());
    if (typeof this.formValue === 'string' && this.formValue.trim() === '') {
      window.location.href = applyRedirectURL;
      return;
    }
    this.isFollowedLocal.set(
      this.localStorageService.getItem('IsFollowed') === 'true' ? true : false
    );

    const isCurrentlyFollowing = this.isFollowedLocal();

    if (!isCurrentlyFollowing) {
      this.doFollow(false);
    } else {
      if (this.isBrowser) {
        this.renderer.addClass(document.body, 'overflow-hidden');
      }
      this.modalService
        .openModal(this.unfollowModalConfig())
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          finalize(() => {
            if (this.isBrowser) {
              this.renderer.removeClass(document.body, 'overflow-hidden');
            }
          }),
        )
        .subscribe(res => {
          if (res.event?.isConfirm === true) {
            this.doFollow(true);
          }
        });
    }
  }

  private doFollow(isCurrentlyFollowing: boolean): void {
    const followedValue = isCurrentlyFollowing ? 'fed' : 'fei';
    const payload: followRequest = {
      deviceType: this.deviceType,
      formValue: this.formValue,
      id: this.jobDetails()?.CompanyID || '',
      actType: followedValue,
      name: this.jobDetails()?.CompnayName || '',
      categoryId: this.jobDetails()?.CategoryID || '',
      jobId: this.jobDetails()?.JobId || '',
    };
    this.jobDetailsService
      .followJob(payload)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data: followData) => this.handleFollowResponse(data, isCurrentlyFollowing),
        error: () => {
          this.isFollowedLocal.set(this.remainingData().IsFollowed);
          this.toasterService.open('Failed to update follow status. Please try again.', 'error');
        }
      });
  }

  private handleFollowResponse(data: followData, isCurrentlyFollowing: boolean): void {
    this.followResponse = data;
    if (typeof data === 'string') {
      if (this.isBrowser) {
        window.location.href = `${this.signinUrl}${data}`;
      }
    } else {
      this.isFollowedLocal.set(!this.isFollowedLocal());
      this.remainingData().IsFollowed = this.isFollowedLocal();
      this.localStorageService.setItem(
        'IsFollowed',
        this.isFollowedLocal().toString()
      );
      this.toasterService.open(
        isCurrentlyFollowing ? 'follow.removed' : 'follow.added',
        isCurrentlyFollowing ? 'error' : 'success'
      );
    }
  }

  private unfollowModalConfig(): ModalConfig {
    return {
      content: {
        title: 'unfollowTitle',
        content: 'unfollowContent',
        imgSrc: `${environment.homeImageUrl}company-insight-unfollow-warning-logo.svg`,
        contentImg: false,
        closeButtonText: 'unfollowCancel',
        closeButtonbg: '#fff',
        closeButtonColor: '#101828',
        saveButtonText: 'unfollowConfirm',
        isCloseButtonVisible: true,
        isSaveButtonVisible: true,
        showButtonImg: false,
        saveButtonColor: '#C63C92',
        saveButtonHover: '#B32D7D',
        closeButtonHover: '#F9FAFB',
      },
    };
  }

  shortLists() {
    const applyRedirectURL = constructRedirectURL('sj', `save/${this.jobDetails()?.JobId}`, this.transloco.getActiveLang());
    if (typeof this.formValue === 'string' && this.formValue.trim() === '') {
      window.location.href = applyRedirectURL;
      return;
    }

    const jobId = this.jobDetails()?.JobId ?? '';
    const shortListedValue = this.IsShortlistedLocal() ? 0 : 1;
    const payload: shortlistBody = {
      deviceType: this.deviceType,
      formValue: this.formValue,
      jobID: jobId,
      actType: shortListedValue,
      categoryId: this.jobDetails()?.CategoryID.toString() || '',
      jobLanType: this.JobLanType,
    };

    this.jobDetailsService
      .shortListedJob(payload)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response) => this.handleShortlistResponse(response, jobId, shortListedValue),
        error: () => {
          this.toasterService.open('Unable to update saved jobs. Please try again.', 'error');
        },
      });
  }

  private handleShortlistResponse(data: shortListResponse, jobId: string, shortListedValue: number): void {
    this.mess = data.data;
    if (typeof this.mess !== 'object' && this.mess !== null) {
      if (this.isBrowser) {
        window.location.href = `${this.signinUrl}${this.mess}`;
      }
      return;
    }

    const isSaved = shortListedValue === 1;
    // this.isShortListed.set(true);
    // if (this.isBrowser) {
    //   setTimeout(() => {
    //     this.isShortListed.set(false);
    //   }, 5000);
    // }

    this.IsShortlistedLocal.set(isSaved);
    this.remainingData().IsShortlisted = isSaved;
    this.updateSavedJobsCache(isSaved, jobId);

    this.shortListMsg = isSaved
      ? 'shortlist.added'
      : 'shortlist.removed';

    this.toasterService.open(
      this.shortListMsg,
      'success'
    );
  }

  private updateSavedJobsCache(isSaved: boolean, jobId: string): void {
    if (!jobId) return;
    if (isSaved) {
      this.savedJobsCache.addJobId(this.MybdjobsGuid(), jobId);
    } else {
      this.savedJobsCache.removeJobId(this.MybdjobsGuid(), jobId);
    }
  }
  offeredJob() {
    this.onMoreJobModal();
    if (this.moreJobs().length === 0) {
      const payload: MoreJobsPayload = {
        deviceType: this.deviceType,
        formValue: this.formValue,
        Company_ID: this.jobDetails()?.CompanyID || '',
        Company_Name: this.jobDetails()?.CompnayName || '',
        Alias_Status: this.Alias_Status,
      };
      this.jobDetailsService
        .getMoreJobsFromCompanies(payload)
        .pipe(takeUntilDestroyed(this.destroyRef), shareReplay(1))
        .subscribe({
          next: (moreJobs: MoreJobsData[]) => {
            this.moreJobs.set(moreJobs);
          },
          error: (error) => {
            this.errorMessage = 'Failed to fetch jobs. Please try again later.';
            console.error(error);
          },
        });
    }
    return this.moreJobs();
  }

  applyNow() {
    if (!this.isBrowser) return;
    const preferResume =
      this.jobDetails()?.PreferVideoResume === 1 ? 'True' : 'False';
    const salaryUsage = this.jobDetails()?.test === 1 ? 'True' : 'False';

    const params: any = {
      cart_id: this.jobDetails()?.JobId || '',
      JOB_ID: this.jobDetails()?.JobId || '',
      JOB_SEX: this.jobDetails()?.Gender || '',
      COMPANY_E_MAIL: this.jobDetails()?.ApplyEmail || '',
      JOB_TITLE: this.jobDetails()?.JobTitle || '',
      APPLICATION: 'fg',
      CONFIDENTIAL: '',
      JOB_CID: this.jobDetails()?.CategoryID || '',
      hdPhotograph: this.jobDetails()?.Photograph || '',
      txtservice: this.jobDetails()?.JobAdType,
      COMPANY_NAME: this.jobDetails()?.CompnayName || '',
      hidExcessiveCheck: salaryUsage,
      Src: 0,
      isVideoResumePreferred: preferResume,
      tmpSalaryRange: this.jobDetails()?.JobSalaryRange || '',
    };

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = this.transloco.getActiveLang()==='en' ? environment.applyOnlineAsp : environment.applyOnlineAspBn;

    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = params[key];
        form.appendChild(input);
      }
    }

    document.body.appendChild(form);
    form.submit();
  }

  applyOnline():void{
    if(this.formValue !== null && this.formValue !== ''){
      this.circularLoaderService.setLoading(true)
    }
    else{
      if(this.isBrowser){
        const applyRedirectURL = constructRedirectURL('jd', `apply/${this.jobDetails()?.JobId}`, this.transloco.getActiveLang());
        window.location.href = applyRedirectURL
      }
    }
  }

  // updateSections() {
  //   this.sections = [
  //     {
  //       id: 'allSection',
  //       label: this.transloco.translate('All'),
  //       condition: true,
  //     },
  //     {
  //       id: 'requirements',
  //       label: this.transloco.translate('Requirements'),
  //       condition: this.isRequirements(),
  //     },
  //     {
  //       id: 'responsibilitiesSection',
  //       label: this.transloco.translate('Responsibilities'),
  //       condition: this.isResponsibilities(),
  //     },
  //     {
  //       id: 'skills',
  //       label: this.transloco.translate('Skills_&_Expertise'),
  //       condition: this.isSkill(),
  //     },
  //     {
  //       id: 'salary',
  //       label: this.transloco.translate('Salary_&_Benefits'),
  //       condition: this.isSalary(),
  //     },
  //     {
  //       id: 'companyInfo',
  //       label: this.transloco.translate('Company_Information'),
  //       condition: true,
  //     },
  //   ];
  // }

  scrollToTop() {
    if (this.isBrowser) {
      this.topElement?.nativeElement?.scrollIntoView({ behavior: 'smooth' });
    }
  }

  scrollToBottom() {
    if (this.isBrowser) {
      this.accessElement?.nativeElement?.scrollIntoView({ behavior: 'smooth' });
    }
  }

  scrollToSection(section: string) {
    this.selectedSection = section;
    if (this.isBrowser) {
      const element = document.getElementById(section);
      if (element !== null) {
        const yOffset = -120;
        const y =
          element.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.checkScreenSize();
  }

  checkScreenSize() {
    if (this.isBrowser) {
      this.isSmallDevice = window.innerWidth <= 740;
    }
  }

  onMoreJobModal() {
    this.isMoreJobModalOpen = true;
    if (this.isBrowser) {
      this.renderer.addClass(document.body, 'overflow-hidden');
    }
  }

  closeMoreJobModal() {
    this.isFollowedLocal.set(
      this.isFollowedLocal().toString() ===
        this.localStorageService.getItem('IsFollowed')
        ? this.isFollowedLocal()
        : !this.isFollowedLocal()
    );
    this.isMoreJobModalOpen = false;
    if (this.isBrowser) {
      this.renderer.addClass(document.body, 'overflow-auto');
      this.renderer.removeClass(document.body, 'overflow-hidden');
    }
  }

  private saveJobDetailsViewData(id: string): void {
    const stored = this.localStorageService.getItem('jobdetails');
    const existingJobs: { jobId: string; count: number }[] = stored
      ? JSON.parse(stored)
      : [];

    const jobIndex = existingJobs.findIndex((job: { jobId: string; count: number }) => job.jobId === id);

    if (jobIndex !== -1) {
      existingJobs[jobIndex].count += 1;
    } else {
      existingJobs.push({ jobId: id, count: 1 });
    }

    this.localStorageService.setItem('jobdetails', JSON.stringify(existingJobs));
  }


  private logJobsAnalytics(jobId: number): void {
    this.analyticsService.logView([jobId], AnalyticsViewEnum.JobDetails);
  }

  protected redirectToPricingPage():void{
    trackButtonClick('JD_Pro_Matching');
    window.open(this.pricingPageUrl, '_blank');
  }

  private loadCompanyInsight(companyId: string): void {
    this.companyInsightService.getInsight(companyId, false, this.MybdjobsGuid())
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map(response => {
          const value = response?.[0]?.eventData?.[0]?.value;
          const data = Array.isArray(value) ? (value[0] ?? null) : (value ?? null);
          const insightData = data as CompanyInsightApiEventData | null ;

          if (insightData && Array.isArray(insightData.industryInfos)) {
            insightData.industryInfos = [
              ...new Map(
                insightData.industryInfos.map((i: CompanyInsightApiIndustryInfo) => [i.industryName, i])
              ).values()
            ];
          }

return insightData;
        }),
        catchError(() => of(null))
      )
      .subscribe(data => this.companyInsight.set(data));
  }

  private updateMatchingScoreStorage(matchingData: MatchingResponse[]): void {
    const jobId = this.JobID().toString();
    const score = matchingData?.[0]?.applicantMatchingScore?.toString() ?? '0';

    const matchingScoreStorageArr = this.getMatchingScoreArr();
    const existingIndex = matchingScoreStorageArr.findIndex(
      (item: MatchingScoreItem) => item.jobId === jobId
    );

    if (existingIndex !== -1) {
      matchingScoreStorageArr[existingIndex].matchingScore = score;
    } else {
      matchingScoreStorageArr.push({ jobId, matchingScore: score });
      if (matchingScoreStorageArr.length > 10) {
        matchingScoreStorageArr.shift();
      }
    }

    this.localStorageService.setItem(
      LocalStorageItem.MATCHING_SCORE_ARR,
      JSON.stringify(matchingScoreStorageArr)
    );
  }

  private getMatchingScoreArr(): MatchingScoreItem[] {
    const matchingArr = this.localStorageService.getItem(
      LocalStorageItem.MATCHING_SCORE_ARR
    );

    if (matchingArr && matchingArr.trim().startsWith('[')) {
      const parsed = JSON.parse(matchingArr);
      if (Array.isArray(parsed)) {
        return parsed;
      }
    }

    return [];
  }

  private handleBackNavigation():void{
    switch(this.navigationOrigin()){
      case 'home':
        this.router.navigate(['/']);
        return;
      case COMPANY_INSIGHT:
        this.router.navigate(['/company-insight', this.jobDetails()?.CompanyID]);
        return;
      default :
        this.router.navigate([this.jobs_url],{
          queryParams:{isBack : true}
        });
        return;
    }
  }

  readonly activeLang = toSignal(this.transloco.langChanges$, {
    initialValue: this.transloco.getActiveLang(),
  });
  readonly sectionRecord = computed<Record<SectionId, { labelKey: string; visible: boolean }>>(() => ({
    allSection: { labelKey: 'All', visible: true },
    requirementsSection: { labelKey: 'Requirements', visible: this.isRequirements() },
    responsibilitiesSection: { labelKey: 'Responsibilities', visible: this.isResponsibilities() },
    skillsSection: { labelKey: 'Skills_&_Expertise', visible: this.isSkill() },
    salarySection: { labelKey: 'Salary_&_Benefits', visible: this.isSalary() },
  }));

  readonly visibleSections = computed(() =>
    Object.entries(this.sectionRecord())
      .filter(([, s]) => s.visible)
      .map(([id, s]) => ({ id: id as SectionId, labelKey: s.labelKey }))
  );

  readonly activeSection = signal<SectionId>('allSection');
  readonly isCompactHeaderVisible = signal(false);
  private isManualScrolling = false;
  private manualScrollTimer: ReturnType<typeof setTimeout> | null = null;

  @HostListener('window:scroll')
  onWindowScroll(): void {
    if (!this.isBrowser) {
      return;
    }

    const jobHeader = document.getElementById('jobDetailsHeader');
    if (jobHeader) {
      const transitionPoint = jobHeader.offsetTop + jobHeader.offsetHeight;
      const scrollTop = window.scrollY;
      const shouldShowCompactHeader = this.isCompactHeaderVisible()
        ? scrollTop > transitionPoint - 48
        : scrollTop > transitionPoint + 16;

      if (shouldShowCompactHeader !== this.isCompactHeaderVisible()) {
        this.isCompactHeaderVisible.set(shouldShowCompactHeader);
      }
    }

    if (this.isManualScrolling) {
      return;
    }

    if (window.scrollY < 100) {
      this.activeSection.set('allSection');
      return;
    }

    const stickyOffset = this.getStickyHeaderOffset() + 30;
    const currentSection = this.visibleSections()
      .map(({ id }) => ({
        id,
        top: document.getElementById(id)?.getBoundingClientRect().top ?? Number.POSITIVE_INFINITY,
      }))
      .filter(({ top }) => top <= stickyOffset)
      .at(-1);

    this.activeSection.set(currentSection?.id ?? 'allSection');
  }

  scrollToSections(sectionId: SectionId): void {
    this.activeSection.set(sectionId);

    if (!this.isBrowser) {
      return;
    }

    this.isManualScrolling = true;
    if (this.manualScrollTimer) {
      clearTimeout(this.manualScrollTimer);
    }
    this.manualScrollTimer = setTimeout(() => {
      this.isManualScrolling = false;
    }, 1000);

    if (sectionId === 'allSection') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      return;
    }

    const element = document.getElementById(sectionId);
    if (!element) {
      return;
    }

    const isMobile = window.innerWidth < 768;
    const stickyOffset = this.getStickyHeaderOffset();
    const padding = 20;

    let layoutShift = 0;
    if (!isMobile && !this.isCompactHeaderVisible()) {
      const videoCv = document.querySelector('.border-\\[\\#95CDFF\\]');
      if (videoCv && !videoCv.classList.contains('md:hidden')) {
        layoutShift = videoCv.getBoundingClientRect().height + 24;
      }
    }

    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - stickyOffset - padding - layoutShift;

    window.scrollTo({
      top: Math.max(0, Math.round(offsetPosition)),
      behavior: 'smooth',
    });
  }

  private getStickyHeaderOffset(): number {
    if (!this.isBrowser) {
      return 0;
    }
    const isMobile = window.innerWidth < 768;
    if (isMobile) {
      const mobileNav = document.querySelector(
        '.max-md\\:sticky'
      ) as HTMLElement | null;
      return mobileNav ? mobileNav.getBoundingClientRect().height : 64;
    }
    const desktopSticky = document.querySelector(
      '.md\\:sticky'
    ) as HTMLElement | null;
    if (desktopSticky && this.isCompactHeaderVisible()) {
      const height = desktopSticky.getBoundingClientRect().height;
      if (height > 120) {
        return height;
      }
    }
    return 172;
  }

  private scrollActiveTabIntoView(activeId: string): void {
    if (this.navContainer === undefined) return;
    const container = this.navContainer.nativeElement;

    const activeBtn = container.querySelector<HTMLButtonElement>(
      `[data-section-id="${activeId}"]`
    );
    if (!activeBtn) return;

    // only relevant on mobile (scrollable), grid on desktop won't overflow
    const containerLeft = container.getBoundingClientRect().left;
    const btnLeft = activeBtn.getBoundingClientRect().left;
    const offset = btnLeft - containerLeft + container.scrollLeft;

    container.scrollTo({
      left: offset,
      behavior: 'smooth',
    });
  }

  onMatchingDataLoaded(response: MatchingResponse[]): void {
    this.MatchingList.set(response);
    this.matchingApiCalled.set(true);
  }

  scrollToJobLocation(): void {
    if (!this.isBrowser) return;

    const findAndScroll = (retryCount = 0): void => {
      const element = document.getElementById('jobLocationSection');
      if (!element) {
        if (retryCount < 15) {
          setTimeout(() => findAndScroll(retryCount + 1), 100);
        }
        return;
      }

      this.isManualScrolling = true;
      if (this.manualScrollTimer) {
        clearTimeout(this.manualScrollTimer);
      }
      this.manualScrollTimer = setTimeout(() => {
        this.isManualScrolling = false;
      }, 1000);

      const isMobile = window.innerWidth < 768;
      const stickyOffset = this.getStickyHeaderOffset();
      const padding = 20;

      let layoutShift = 0;
      if (!isMobile && !this.isCompactHeaderVisible()) {
        const videoCv = document.querySelector('.border-\\[\\#95CDFF\\]');
        if (videoCv && !videoCv.classList.contains('md:hidden')) {
          layoutShift = videoCv.getBoundingClientRect().height + 24;
        }
      }

      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;
      const offsetPosition =
        elementPosition - stickyOffset - padding - layoutShift;

      window.scrollTo({
        top: Math.max(0, Math.round(offsetPosition)),
        behavior: 'smooth',
      });
    };

    findAndScroll();
  }

}
